/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function* e(o, i) {
  if (o !== void 0) {
    let t = 0;
    for (const f of o)
      yield i(f, t++);
  }
}
export {
  e as o
};
